import { render, staticRenderFns } from "./FormDecimalInput.vue?vue&type=template&id=476a9dc8&"
import script from "./FormDecimalInput.vue?vue&type=script&lang=js&"
export * from "./FormDecimalInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports